
import { Component, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'project-admin-scm-tabs',
  template: `<ul class="nav nav-tabs" role="tablist">
    <li role="presentation" *ngIf="isProjectAdmin" [ngClass]="{'active': stateService.is('home.project.summary.admin.scm')}">
      <a uiSref="home.project.summary.admin.scm" role="tab">
      Settings
      </a>
    </li>
    <li role="presentation" *ngIf="isProjectAdmin" [ngClass]="{'active': stateService.is('home.project.summary.admin.scm.acl')}">
      <a id="projAdminContList" uiSref="home.project.summary.admin.scm.acl" role="tab">
        Access Control List
      </a>
    </li>
</ul>`
})
export class ProjectAdminScmTabsComponent {
  @Input() isProjectAdmin: boolean;

  constructor (public stateService: StateService) {
  }
}
